import { getApiError, getHeaders, getHttpClient } from './CommonFunctions';
import config from '../config';
import {
    fetchingOffices, fetchOfficesFailed, fetchOfficesSuccess, fetchingMembers, fetchMembersSuccess,
    fetchMembersFailed
} from '../actions/RosterActions';

const rosterUrl = config.get('ROSTER_API_URL');

const httpClient = getHttpClient(rosterUrl);

const getOffices = () => {
    const headers = getHeaders();
    return dispatch => {
        dispatch(fetchingOffices());
        httpClient.get('/all-offices', { headers })
            .then(response => {
                dispatch(fetchOfficesSuccess(response.data))
            }).catch(err => {
                const error = getApiError(err);
                dispatch(fetchOfficesFailed(error));
            });
    };
};

const fetchMembers = () => {
    const headers = getHeaders();
    return async dispatch => {
        let members = [];
        const top = 100;
        let skip = 0;
        let nextSet = null;
        let error = null;
        dispatch(fetchingMembers());
        while(nextSet && nextSet.length === top || skip === 0) {
            try {
                await httpClient.get(
                    `members?$orderby=lastName&$skip=${skip}&$top=${top}`,
                    { headers }
                ).then(response => {
                    nextSet = response.data;
                    skip += top;
                    members = [...members, ...nextSet];
                })
            } catch (err) {
                error = getApiError(err);
                dispatch(fetchMembersFailed(error));
            }
        }

        if(!error)
            dispatch(fetchMembersSuccess(members));
    }
};

export {
    getOffices,
    fetchMembers
}
